import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { COUNTRY_CODE_TO_NAME } from 'constants/countries-served';
import { DISTANCE_UNITS, SYSTEMS } from 'constants/measurement';
import { deepExtract } from 'helpers/deep';
var SET_LOCALE = 'classpass/locale/SET_LOCALE';
var SET_USER_LOCALE = 'classpass/locale/SET_USER_LOCALE';
var SET_LOCALE_INFO = 'classpass/locale/SET_LOCALE_INFO';
var SET_COUNTRY = 'classpass/locale/SET_COUNTRY';
var SET_USER_DETECTED_LOCATION = 'classpass/locale/SET_USER_DETECTED_LOCATION';
var SET_USER_SELECTED_LOCATION = 'classpass/locale/SET_USER_SELECTED_LOCATION';
export var setLocale = function setLocale(locale) {
  return {
    type: SET_LOCALE,
    data: locale
  };
};
export var setUserLocale = function setUserLocale(locale) {
  return {
    type: SET_USER_LOCALE,
    data: locale
  };
};
export var setLocaleInfo = function setLocaleInfo(addressRequirements) {
  return {
    type: SET_LOCALE_INFO,
    data: addressRequirements
  };
};
export var setCountry = function setCountry(country, continent) {
  return {
    type: SET_COUNTRY,
    data: {
      country: country,
      continent: continent
    }
  };
};
export var setUserDetectedLocation = function setUserDetectedLocation(lat, lon, accuracy) {
  return {
    type: SET_USER_DETECTED_LOCATION,
    data: {
      lat: lat,
      lon: lon,
      accuracy: accuracy
    }
  };
};
export var setUserSelectedLocation = function setUserSelectedLocation(lat, lon) {
  return {
    type: SET_USER_SELECTED_LOCATION,
    data: {
      lat: lat,
      lon: lon
    }
  };
};
export var selectCountry = deepExtract.bind(null, 'locale.country');
export var selectLocaleInfo = deepExtract.bind(null, 'locale.addressRequirements');
export var selectMeasurementSystem = deepExtract.bind(null, 'locale.measurementSystem');
export var selectUserDetectedLocation = deepExtract.bind(null, 'locale.userDetectedLocation');
export var selectUserLocale = deepExtract.bind(null, 'locale.userLocale');
export var selectUserSelectedLocation = deepExtract.bind(null, 'locale.userSelectedLocation');
export var selectDistanceUnit = function selectDistanceUnit(state) {
  return selectMeasurementSystem(state) === SYSTEMS.imperial ? DISTANCE_UNITS.mi : DISTANCE_UNITS.km;
};
export var selectUserLocation = function selectUserLocation(state) {
  return selectUserSelectedLocation(state) || selectUserDetectedLocation(state);
};
var initialState = {
  continent: '',
  country: '',
  exactCountry: '',
  locale: 'en-US',
  addressRequirements: {},
  measurementSystem: SYSTEMS.metric,
  userDetectedLocation: null,
  userSelectedLocation: null
};

var closestServedCountry = function closestServedCountry(country, continent) {
  if (Object.keys(COUNTRY_CODE_TO_NAME).indexOf(country) !== -1) {
    return country;
  }

  if (continent === 'europe') {
    return 'GBR';
  }

  return 'USA';
};

export default function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_COUNTRY:
      return _objectSpread({}, state, {
        exactCountry: action.data.country,
        continent: action.data.continent,
        country: closestServedCountry(action.data.country, action.data.continent),
        measurementSystem: action.data.country === 'USA' ? SYSTEMS.imperial : SYSTEMS.metric
      });

    case SET_USER_DETECTED_LOCATION:
      return _objectSpread({}, state, {
        userDetectedLocation: action.data
      });

    case SET_USER_SELECTED_LOCATION:
      return _objectSpread({}, state, {
        userSelectedLocation: action.data
      });

    case SET_LOCALE:
      return _objectSpread({}, state, {
        locale: action.data
      });

    case SET_USER_LOCALE:
      return _objectSpread({}, state, {
        userLocale: action.data
      });

    case SET_LOCALE_INFO:
      return _objectSpread({}, state, {
        addressRequirements: action.data
      });

    default:
      return state;
  }
}